import styled from 'styled-components';

interface IContainer {
  $width?: string;
}

export const Container = styled.div<IContainer>`
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: ${({ $width }) => $width ?? '100%'};
  box-sizing: border-box;

  label {
    color: ${({ theme }) => theme.colors?.text.primary};
    margin-bottom: 0.25rem;
  }
`;

interface IFieldShell {
  $height: string;
  $disabled?: boolean;
  $open?: boolean;
}

export const FieldShell = styled.div<IFieldShell>`
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  height: ${({ $height }) => $height};
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors?.gray02};
  border: 1px solid
    ${({ theme, $open }) =>
      $open ? theme.colors?.primary : theme.colors?.gray02};
  box-shadow: ${({ $disabled, theme }) =>
    $disabled ? 'none' : `inset 0px 3px 6px ${theme.colors?.gray04}`};
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
`;

export const CountryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex: 0 0 auto;
  min-width: unset;
  height: 100%;
  margin: 0;
  padding: 0 0.5rem 0 0.75rem;
  border: none;
  border-right: 1px solid ${({ theme }) => theme.colors?.gray03};
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  line-height: 1;
  appearance: none;
  -webkit-appearance: none;
  color: ${({ theme }) => theme.colors?.text.primary};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:focus {
    outline: none;
  }
`;

export const CallingCode = styled.span`
  color: ${({ theme }) => theme.colors?.text.secondary};
  white-space: nowrap;
`;

export const NumberInput = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding: 0 1rem;
  appearance: none;
  -webkit-appearance: none;
  color: ${({ theme }) => theme.colors?.text.primary};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'auto')};

  &:focus {
    outline: none;
  }
`;

export const FlagImg = styled.img`
  width: 1.25rem;
  height: 0.9rem;
  object-fit: cover;
  border-radius: 2px;
  flex-shrink: 0;
`;

export const FlagFallback = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs10};
  color: ${({ theme }) => theme.colors?.text.secondary};
`;

export const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 18rem;
  max-width: min(90vw, 28rem);
  max-height: 18rem;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors?.gray03};
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
  box-shadow: 0 4px 12px ${({ theme }) => theme.colors?.gray04};
`;

export const SearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.colors?.gray03};
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 8px;
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
  color: ${({ theme }) => theme.colors?.text.primary};

  &:focus {
    outline: none;
  }
`;

export const CountryList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  max-height: 14rem;
`;

export const CountryOption = styled.li<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors?.text.primary};
  background-color: ${({ theme, $selected }) =>
    $selected ? theme.colors?.gray02 : 'transparent'};

  &:hover {
    background-color: ${({ theme }) => theme.colors?.primary};
    color: ${({ theme }) => theme.colors?.text.tertiary};
  }

  &:hover ${CallingCode} {
    color: ${({ theme }) => theme.colors?.text.tertiary};
  }
`;

export const CountryName = styled.span`
  flex: 1;
  min-width: 0;
  white-space: nowrap;
`;

export const Empty = styled.div`
  padding: 12px;
  text-align: center;
  color: ${({ theme }) => theme.colors?.text.secondary};
`;

export const StyledError = styled.p`
  color: ${({ theme }) => theme.colors?.danger};
  margin: 0.25rem 0 0;
`;
